import { render, staticRenderFns } from "./LogTab.vue?vue&type=template&id=bf45d39e"
import script from "./LogTab.vue?vue&type=script&lang=js"
export * from "./LogTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports